import { render, staticRenderFns } from "./ProductsFilters.vue?vue&type=template&id=ddab3c38"
import script from "./ProductsFilters.vue?vue&type=script&lang=js"
export * from "./ProductsFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductsFilters.vue?vue&type=style&index=0&id=ddab3c38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports